import React from "react";

import { ArrowRightIcon, PlusIcon } from "@/assets/icons";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator
} from "@/components/ui/breadcrumb";
import { Button } from "@/components/ui/button";

type BreadcrumbConfigProps = {
  label: string;
  path?: string;
};
interface DashboardHeaderProps {
  title?: string;
  createButtonText?: string;
  breadcrumbConfig: BreadcrumbConfigProps[];
  onCreateClick: () => void;
  createPermission?: boolean;
}

const buildBreadCrumb = (breadcrumbConfig: BreadcrumbConfigProps[]) => {
  return (
    <Breadcrumb>
      <BreadcrumbList className="!gap-1 items-center">
        {breadcrumbConfig.map((item, index) => (
          <React.Fragment key={`breadcrumb-${item.label}-${index}`}>
            <BreadcrumbItem>
              {item.path ? (
                <BreadcrumbLink
                  data-testid="breadcrumb-back-link"
                  href={item.path}
                >
                  {item.label}
                </BreadcrumbLink>
              ) : (
                <BreadcrumbPage>{item.label}</BreadcrumbPage>
              )}
            </BreadcrumbItem>
            {index < breadcrumbConfig.length - 1 && (
              <BreadcrumbSeparator>
                <ArrowRightIcon fill="#CECECE" width={12} height={12} />
              </BreadcrumbSeparator>
            )}
          </React.Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
};

const DashboardHeader = ({
  title = "Users",
  createButtonText = "Create User",
  breadcrumbConfig,
  onCreateClick,
  createPermission = false
}: DashboardHeaderProps) => {
  return (
    <>
      <div className="flex items-center">
        {buildBreadCrumb(breadcrumbConfig)}
      </div>
      <div className="flex items-center justify-between">
        <h1 className="text-txtHeading text-2xl font-semibold">{title}</h1>
        {createPermission && (
          <Button
            onClick={onCreateClick}
            className="px-6 py-3 font-semibold text-white rounded-xl gap-1"
          >
            <PlusIcon className="fill-white" />
            {createButtonText}
          </Button>
        )}
      </div>
    </>
  );
};

export default DashboardHeader;
